"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTPSLByOrderId = void 0;
const react_1 = require("react");
const rx_1 = require("./rx");
/**通过order id查询止盈止损单 */
function useTPSLByOrderId(orderId, active = true) {
    const [tpOrder, setTpOrder] = (0, react_1.useState)();
    const [slOrder, setSlOrder] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = rx_1.orderConsumeSubject.subscribe({
            next: () => {
                const { tpOrderMap, slOrderMap } = rx_1.ActiveOrderTPSLStore;
                setTpOrder(tpOrderMap.get(orderId));
                setSlOrder(slOrderMap.get(orderId));
            },
            error: () => { }
        });
        return () => sub.unsubscribe();
    }, [active, orderId]);
    return {
        tpOrder,
        slOrder,
    };
}
exports.useTPSLByOrderId = useTPSLByOrderId;
